// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__vh4us","overflowing":"ReadFullNote_overflowing__134Mj"};